import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWeatherNightClear = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Regular",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "weather-night-clear" }),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M17.235,15.75A9.752,9.752,0,0,1,7.91,3.151a9.746,9.746,0,1,0,13.4,11.7A9.689,9.689,0,0,1,17.235,15.75Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 11.985,
			y1: 3.75,
			x2: 16.485,
			y2: 3.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 14.235,
			y1: 1.5,
			x2: 14.235,
			y2: 6
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 18.735,
			y1: 8.25,
			x2: 21.735,
			y2: 8.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 20.235,
			y1: 6.75,
			x2: 20.235,
			y2: 9.75
		})
	]
});
export default SvgWeatherNightClear;
